"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _merge2 = _interopRequireDefault(require("lodash/merge"));

var _enUS = _interopRequireDefault(require("../i18n/en-US.json"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var instance;

var I18nManager =
/*#__PURE__*/
function () {
  function I18nManager() {
    _classCallCheck(this, I18nManager);

    this.i18nMap = null;
    this.locale = 'en-US';
  }

  _createClass(I18nManager, [{
    key: "initialize",
    value: function initialize(i18nMap) {
      this.i18nMap = i18nMap;
    }
    /**
     * Merge new mapping to existing map.
     *
     * @param {object} i18nMap - new i18nmap to be merged.
     */

  }, {
    key: "merge",
    value: function merge(i18nMap) {
      this.i18nMap = (0, _merge2.default)(this.i18nMap, i18nMap);
    }
    /**
     * Given key to the i18nMap return the value.
     * @param {string} moduleName - the module name this key is under.
     * @param {string} key - lookup key.
     * @return {string} - translated string if found else return the original key
     */

  }, {
    key: "t",
    value: function t(moduleName, key) {
      // If this.i18nMap is not initialized, initialize it with our en-US strings
      if (!this.i18nMap) {
        this.initialize(_enUS.default);
      }

      if (typeof key !== 'string') {
        return key;
      }

      var translation = this.i18nMap[moduleName] || {}; // Return the value if key is found in the module section,
      // else try root section, then if all else failed return
      // the original key.

      var result = translation[key] || this.i18nMap[key];

      if (typeof result !== 'string') {
        return key;
      }

      return result;
    }
    /**
     * Set the current locale
     * @param {string} locale - Locale to set
     */

  }, {
    key: "setLocale",
    value: function setLocale(locale) {
      this.locale = locale;
    }
    /**
     * Get the current locale
     * @returns {string} - Current locale
     */

  }, {
    key: "getLocale",
    value: function getLocale() {
      return this.locale;
    }
    /**
     * Format number to current locale standards
     * @param {string|number} number - Number to format
     * @returns {string} Formatted number
     */

  }, {
    key: "formatNumber",
    value: function formatNumber(number) {
      var locale = this.getLocale();

      if (locale && window.Intl && _typeof(window.Intl) === 'object' && typeof window.Intl.NumberFormat === 'function') {
        return new Intl.NumberFormat(locale).format(number);
      } // Return raw number if locale was set to something falsy or if browser
      // does not support Intl.NumberFormat API


      return number.toString();
    }
  }]);

  return I18nManager;
}();

var _default = instance || (instance = new I18nManager());

exports.default = _default;